// URL kept as /connectors/retrieval-paths even though the page is now the Civala
// Corpus brief — links to it are already circulating. The file name is bound to the
// route, so it stays; the page component carries the current name.
import { createFileRoute } from "@tanstack/react-router"

import { CorpusOverview } from "@/pages/CorpusOverview"

export const Route = createFileRoute("/connectors/retrieval-paths")({
  component: CorpusOverview,
})
